module.exports = __webpack_public_path__ + "static/media/logo.87b38358.png";